import React from 'react'
import styled from 'styled-components'
import PreviewLogo from '~/images/previewLogo.svg'

const TypeWrapper = styled.div`
  width: 100%;
  height: 0;
  padding-top: 100%;

  svg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`

export const Background = ({ sizes, backgroundColor }) => (
  <svg
    viewBox={`0 0 ${sizes}`}
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <rect
      width="100%"
      height="100%"
      style={{
        fill: backgroundColor,
      }}
    />
  </svg>
)

export const Type = ({ characterPath: { d, bounds }, textColor }) => {
  d = [d].flat()
  return (
    <TypeWrapper>
      <svg
        viewBox={`0 0 ${bounds.width} ${bounds.height}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        {d.map((item, index) => (
          <path key={index} d={item} fill={textColor}></path>
        ))}
      </svg>
    </TypeWrapper>
  )
}

export const Text = ({
  children,
  color,
  originalSizes,
  fontSize,
  textOffset,
  letterSpacing,
}) => {
  const [w, h] = originalSizes

  const arrChildren = children
    .split('\n')
    .map(item => item.replace(/(.{70})/g, '$1\n').split('\n'))
    .flat()

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      style={{
        position: 'absolute',
        bottom: 0,
        fontSize: `${w}px`,
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="50%"
        y={`${100 - parseFloat(`${(100 * (fontSize + 2)) / textOffset}%`)}%`}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={`${(100 * fontSize) / w}%`}
        letterSpacing={letterSpacing}
        fill={color}
      >
        <tspan x="50%" dy={arrChildren[1] ? '-.5em' : 0} fontWeight={800}>
          {arrChildren[0].toUpperCase()}
        </tspan>

        <tspan x="50%" dy={`${(100 * fontSize) / w}%`} fontSize={`65%`}>
          {arrChildren[1].toUpperCase()}
        </tspan>
      </text>
    </svg>
  )
}

export const Logo = props => {
  return <PreviewLogo {...props} />
}
